import { render, staticRenderFns } from "./FundingDetails.vue?vue&type=template&id=b4cc862c&scoped=true&"
import script from "./FundingDetails.vue?vue&type=script&lang=js&"
export * from "./FundingDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetails.vue?vue&type=style&index=0&id=b4cc862c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cc862c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
